import { inject } from '@angular/core';
import { UserService } from './user.service';

export function initializeUser(): Promise<unknown> {
  const userService = inject(UserService);
  return userService.loadUser().toPromise();
}
